export const RATES_DUCK = 'rates'

export const RATES_UPDATE_RATES = 'rates/UPDATE_RATES'
export const RATES_UPDATE_INTERVAL_ID = 'rates/UPDATE_INTERVAL_ID'

